import { CONTROL_TOOLTIPS } from '@src/containers/Blotters/tooltips';
import { FormControlSizes, Toggle } from '@talos/kyoko';
import type { BalancesBlotterShowBy } from '../../../../Blotters/BalancesV2/types';
import { MobileCompactCardsToggle } from '../MobileCompactCardsToggle';
import { MobileShowAllDecimalsToggle } from '../MobileShowAllDecimalsToggle';

interface MobileBalancesSettingsTogglesProps {
  groupAccounts: boolean;
  onGroupAccountsToggle: (checked: boolean) => void;
  onShowZeroBalancesToggle: (checked: boolean) => void;
  showBy: BalancesBlotterShowBy;
  showZeroBalances: boolean;
}

export function MobileBalancesSettingsToggles({
  groupAccounts,
  onGroupAccountsToggle,
  onShowZeroBalancesToggle,
  showBy,
  showZeroBalances,
}: MobileBalancesSettingsTogglesProps) {
  return (
    <>
      <MobileCompactCardsToggle type="Balance" />
      <Toggle
        label="Show Zero Balances"
        size={FormControlSizes.Default}
        tooltip={CONTROL_TOOLTIPS.showZeroBalances}
        checked={showZeroBalances}
        onChange={onShowZeroBalancesToggle}
        fullWidth
      />
      <Toggle
        label="Group Accounts"
        size={FormControlSizes.Default}
        disabled={showBy === 'asset'}
        checked={groupAccounts}
        onChange={onGroupAccountsToggle}
        fullWidth
      />
      <MobileShowAllDecimalsToggle />
    </>
  );
}
